// extracted by mini-css-extract-plugin
export default {"ad":"asideContainer_ad__+c19T"};